import { render, staticRenderFns } from "./instrumentDetail.vue?vue&type=template&id=153a7a1a&scoped=true&"
import script from "./instrumentDetail.vue?vue&type=script&lang=js&"
export * from "./instrumentDetail.vue?vue&type=script&lang=js&"
import style0 from "./instrumentDetail.vue?vue&type=style&index=0&id=153a7a1a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153a7a1a",
  null
  
)

export default component.exports